export interface ScheduleTimeZoneOption {
  value: string
  label: string
}

export const CURATED_SCHEDULE_TIMEZONE_OPTIONS: ScheduleTimeZoneOption[] = [
  { value: 'America/Los_Angeles', label: 'Pacific Time' },
  {
    value: 'America/Vancouver',
    label: 'Pacific Time - British Columbia (PCT)',
  },
  { value: 'America/Denver', label: 'Mountain Time' },
  { value: 'America/Chicago', label: 'Central Time' },
  { value: 'America/New_York', label: 'Eastern Time' },
  { value: 'America/Anchorage', label: 'Alaska Time' },
  { value: 'America/Phoenix', label: 'Arizona, Yukon Time' },
  { value: 'America/St_Johns', label: 'Newfoundland Time' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
  { value: 'America/Indiana/Indianapolis', label: 'Indiana (East) Time' },
]

export const EXTENDED_SCHEDULE_TIMEZONE_OPTIONS: ScheduleTimeZoneOption[] = [
  ...CURATED_SCHEDULE_TIMEZONE_OPTIONS,
  { value: 'Europe/London', label: 'Greenwich Mean Time (UK)' },
  { value: 'America/Adak', label: 'America/Adak' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires Time' },
  { value: 'America/Asuncion', label: 'Asuncion Time' },
  { value: 'America/Bogota', label: 'Bogota, Jamaica, Lima Time' },
  { value: 'America/Campo_Grande', label: 'America/Campo Grande' },
  { value: 'America/Caracas', label: 'Caracas Time' },
  { value: 'America/Godthab', label: 'America/Godthab' },
  { value: 'America/Halifax', label: 'Atlantic Time' },
  {
    value: 'America/Regina',
    label: 'Saskatchewan, Guatemala, Costa Rica Time',
  },
  { value: 'America/Havana', label: 'America/Havana' },
  { value: 'America/Mazatlan', label: 'America/Mazatlan' },
  { value: 'America/Mexico_City', label: 'Mexico City Time' },
  { value: 'America/Montevideo', label: 'Montevideo Time' },
  { value: 'America/Miquelon', label: 'America/Miquelon' },
  { value: 'America/Noronha', label: 'America/Noronha' },
  { value: 'America/Santiago', label: 'Santiago Time' },
  { value: 'America/Santa_Isabel', label: 'America/Santa Isabel' },
  { value: 'America/Moncton', label: 'Atlantic Daylight Time' },
  { value: 'America/Sao_Paulo', label: 'Brasilia Time' },
]
